import { Marker, type Map as MapLibreMap } from 'maplibre-gl'

/**
 * 1B's pin: an 18 px accent square with a 3 px ground border (Phase 10 plan
 * §6). A custom element rather than MapLibre's default teardrop, whose colour
 * is baked in at creation; this one is drawn by `.map-pin` in `app.css` from
 * the tokens, so it follows the theme without being re-created.
 */
function pinElement(): HTMLElement {
  const el = document.createElement('div')
  el.className = 'map-pin'
  // Decorative: the place it marks is named by the section panel's header.
  el.setAttribute('aria-hidden', 'true')
  return el
}

/**
 * The selected point. A MapLibre `Marker` is a DOM element positioned over the
 * canvas, not a style layer, so it survives `setStyle` and needs no re-adding
 * when the basemap changes.
 */
export class LocationMarker {
  private marker: Marker | null = null

  constructor(private readonly map: MapLibreMap) {}

  set(lat: number, lon: number): void {
    if (!this.marker) {
      // Centred on the point: a square has no tip to stand on.
      this.marker = new Marker({ element: pinElement(), anchor: 'center' })
        .setLngLat([lon, lat])
        .addTo(this.map)
      return
    }
    this.marker.setLngLat([lon, lat])
  }

  clear(): void {
    this.marker?.remove()
    this.marker = null
  }
}
